/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_Frame_AltInputs */

const en_mk_hero_frame_alt = /** @type {(inputs: Mk_Hero_Frame_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep roadmap: a PRD on the left, feature canvas in the middle, Bystep Agent on the right`)
};

const id_mk_hero_frame_alt = /** @type {(inputs: Mk_Hero_Frame_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roadmap Bystep: PRD di kiri, kanvas fitur di tengah, Bystep Agent di kanan`)
};

/**
* | output |
* | --- |
* | "Bystep roadmap: a PRD on the left, feature canvas in the middle, Bystep Agent on the right" |
*
* @param {Mk_Hero_Frame_AltInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_frame_alt = /** @type {((inputs?: Mk_Hero_Frame_AltInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_Frame_AltInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_frame_alt(inputs)
	return en_mk_hero_frame_alt(inputs)
});